import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {PasswordParams} from '../models/passwordParams.model';
import {User, UserParam} from '../models/user.model';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getUser(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/v1/user?size=100`, {'headers': headers});
  }

  getUsers(): Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/user/all`);
  }

  getUserSeller(): Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/user/seller`);
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/user` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getUserBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/user` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }

  saveUser(user: User) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/user`, user, {'headers': headers});
  }

  getidUser(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/v1/user/` + idA, {'headers': headers});
  }

  //api/user/commercial/byCommercial/{idCom}
  getCommercialByCodeCommercial(code : string){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/user/comByComID/` + code, {'headers': headers});
  }

  getByUSerName(username: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/v1/user/userID/` + username, {'headers': headers});
  }

  updatePassword(passwordParams: PasswordParams) {
    return this.http.post<any>(`${environment.url}/user/update-password/`, passwordParams);
  }

  getUserByEmail(email: String | undefined) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/user/email/` + email, {'headers': headers});
  }

  forgetPasword(email: String) {
    return this.http.post<any>(`${environment.url}/user/forgetedPassword`, email);
  }

  updateUser(user: User) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/user/` + user.id, user, {'headers': headers});
  }

  activate(user: User) {
    return this.http.post<any>(`${environment.url}/auth/activate`, user);
  }

  disactivate(user: number) {
    return this.http.put<any>(`${environment.url}/auth/disactivate/` + user, null);
  }
  activateAccount(user: number) {
    return this.http.put<any>(`${environment.url}/auth/activate-account/` + user, null);
  }
  resetPassword(user: User) {
    return this.http.put<User>(`${environment.url}/user/reset-password/` + user.id, user);
  }
  deleteUser(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/user/` + idA, {'headers': headers});
  }

  updateUserToBecomeCommercial(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/user/becomeCommercial/` + idA, {'headers': headers});
  }

  abortUserToBecomeCommercial(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/user/abortCommercial/` + idA, {'headers': headers});
  }

  passwordMacthValidator(password: string, passwordrepeat: string) {
    return (formGroup: FormGroup) => {
      {
        //récupère le password et confrim password saisie dan smle formulaire
        const passwordControl = formGroup.controls[password];
        const confirmpasswordControl = formGroup.controls[passwordrepeat];

        if (confirmpasswordControl.errors && !confirmpasswordControl.errors.passwordMismatch) {
          return null;
        }
        //le password et confirmpassword sont false
        if (!passwordControl || !confirmpasswordControl) {
          return null;
        }
        if (passwordControl.value !== confirmpasswordControl.value) {
          confirmpasswordControl.setErrors({ passwordMismatch: true });
        } else {
          confirmpasswordControl.setErrors(null);
        }
        return null;
      };

    }
  }

  /*
  ************** user ^params ******************
   */

  getParamByUserId(userId:string): Observable<any> {
    return this.http.get<any>(`${environment.url}/userParam/userId/` + userId);
  }

  getParamByUser(): Observable<any> {
    return this.http.get<any>(`${environment.url}/userParam`);
  }

  getAllUserParam(): Observable<any> {
    return this.http.get<any>(`${environment.url}/userParam/userParams` );
  }

  getAllParams() {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/param`, {'headers': headers} );
  }

  saveUserParam(userParam:UserParam): Observable<any> {
    return this.http.post<any>(`${environment.url}/userParam`, userParam );
  }

  updateUserParam(id:any, userParam:UserParam): Observable<any> {
    return this.http.post<any>(`${environment.url}/userParam/`+id, userParam );
  }

  verifUserEmail(email: String)
  {
    return this.http.post<any>(`${environment.url}/user/isEmail`, email);
  }

  getNbPostPublished(id: number): Observable<any>{
    return this.http.get(`${environment.url}/post/countByUser/${id}`);
  }

  getNbPurchase(id: number): Observable<any>{
    return this.http.get(`${environment.url}/order_item/countSellByUser/${id}`);
  }

  getUsers_v1(page: number, size: number, userSearchText?: string,startDate?: string, endDate?: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  
    // Construction de la requête URL avec les paramètres
    let url = `${environment.url}/v1/users?page=${page}&size=${size}`;
    
    // Si le paramètre `userSearchText` est fourni, on l'ajoute à l'URL
    if (userSearchText) {
      url += `&userSearchText=${encodeURIComponent(userSearchText)}`;
    }
    // Ajout des dates de début et de fin si elles sont fournies
    if (startDate) {
      url += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      url += `&endDate=${encodeURIComponent(endDate)}`;
    }
  
    return this.http.get<any>(url, { headers });
  }

  getUsersWithSoldProducts(page: number, size: number, userSearchText?: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  
    // Construction de la requête URL avec les paramètres
    let url = `${environment.url}/v1/users/users-with-sold-products?page=${page}&size=${size}`;
    
    // Si le paramètre `userSearchText` est fourni, on l'ajoute à l'URL
    if (userSearchText) {
      url += `&userSearchText=${encodeURIComponent(userSearchText)}`;
    }
  
    return this.http.get<any>(url, { headers });
  }

  
}
